import { useCallback, useMemo, useState } from "react";
import { useTypedSearchParams } from "react-router-typesafe-routes";
import type { ReferenceListFilters } from "~/features/references/types";
import { v2Route } from "~/v2/routes";
import { ReferencesPresenter } from "./references.presenter";

export function ReferencesContainer() {
  const [params, setParams] = useTypedSearchParams(v2Route.references);
  const [excludeDeactivated, setExcludeDeactivated] = useState(true);
  const [createOpen, setCreateOpen] = useState(false);

  const filters: ReferenceListFilters = useMemo(() => ({ excludeDeactivated }), [excludeDeactivated]);

  const selectedReference = params.selectedReference ?? null;
  const onSelect = useCallback((id: string) => setParams((prev) => ({ ...prev, selectedReference: id })), [setParams]);
  const onCloseSelected = useCallback(
    () => setParams((prev) => ({ ...prev, selectedReference: undefined })),
    [setParams],
  );

  return (
    <ReferencesPresenter
      filters={filters}
      onExcludeDeactivatedChange={setExcludeDeactivated}
      onSelect={onSelect}
      selectedReference={selectedReference}
      onCloseSelected={onCloseSelected}
      createOpen={createOpen}
      onOpenCreate={() => setCreateOpen(true)}
      onCloseCreate={() => setCreateOpen(false)}
    />
  );
}
